import { ReactNode } from 'react';
import SAlert from 'react-s-alert';
import { twMerge } from 'tailwind-merge';

type Props = {
  enableRTL?: boolean;
  disableFlex?: boolean;
  disableContent?: boolean;
  disabledOpacity?: number;
  className?: string;
  children: ReactNode;
};

const UtilitiesWrapper = ({
  enableRTL = false,
  disableFlex = false,
  disableContent = false,
  disabledOpacity = 0.5,
  className = '',
  children,
}: Props) => {
  return (
    <div
      dir={enableRTL ? 'rtl' : 'ltr'}
      className={twMerge(
        !disableFlex ? 'flex flex-1 relative' : undefined,
        enableRTL ? 'text-right' : undefined,
        'transition-opacity duration-500 ease-linear',
        className,
      )}
      style={{
        opacity: disableContent ? disabledOpacity : 1,
      }}
    >
      {disableContent && (
        <div
          className="absolute w-full h-full z-[999]"
          onClick={() => {
            SAlert.warning('You must save changes before editing other steps.', {
              timeout: 3000,
            });
          }}
        />
      )}

      {children}
    </div>
  );
};

export default UtilitiesWrapper;
